import { render, staticRenderFns } from "./scoreEntryStudent.vue?vue&type=template&id=a91cc78a&scoped=true"
import script from "./scoreEntryStudent.vue?vue&type=script&lang=js"
export * from "./scoreEntryStudent.vue?vue&type=script&lang=js"
import style0 from "./scoreEntryStudent.vue?vue&type=style&index=0&id=a91cc78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91cc78a",
  null
  
)

export default component.exports